<ng-container *ngIf="checkBoxLoaded; else noDataLoaded">
  <div fxFlex fxLayout>
    <div fxFlex="auto">
      <form *ngIf="form" [formGroup]="form">
        <div class="checkbox-header">
          <span class="checkbox-title "> {{ cid + '.' + listPrefix | translate }}</span>
          <div class="select_all ">
            <mat-checkbox
              #all
              [(ngModel)]="select_all"
              [ngModelOptions]="{ standalone: true }"
              (change)="selectAll($event)"
              [disabled]="dialogData[field?.form?.disabeldIf?.key] === field?.form?.disabeldIf?.value"
            >
              {{ cid + '.select_all' | translate }}</mat-checkbox
            >
          </div>
        </div>

        <div [formGroupName]="key" class="container" *ngFor="let key of keys">
          <p class="name">
            <!-- <mat-checkbox (change)="onSelectAll($event,key)"></mat-checkbox> -->
            {{ cid + '.' + key | translate }}
          </p>

          <mat-checkbox
            (change)="unCheckUnSelectAll($event, all, key)"
            [formControlName]="m.name"
            fxFlex
            fxLayout
            [checked]="m.is_selected"
            *ngFor="let m of modules[key]; let i = index"
            [disabled]="
              dialogData[field?.form?.disabeldIf?.key] === field?.form?.disabeldIf?.value ||
              !m.display_name ||
              m.is_disabled
            "
            [class.hide]="!m.display_name"
          >
            {{ m.display_name }}</mat-checkbox
          >
        </div>
      </form>
    </div>
  </div>
</ng-container>
<ng-template #noDataLoaded>
  <app-skeleton [type]="'roles'"></app-skeleton>
</ng-template>
